import { useEffect, useRef } from 'react';
import { SpeakerPanelItem } from './SpeakerPanelItem';
import type { SpeakerViewItem } from './SpeakerViewScreen';

interface SpeakerPanelAssetsListProps {
  items: SpeakerViewItem[];
  activePresentation: number;
  onDetach: (index: number) => void;
  setActivePresentation: (index: number) => void;
}

const SCROLL_OFFSET = 10;

const SpeakerPanelAssetsList = ({
  items,
  activePresentation,
  setActivePresentation,
  onDetach,
}: SpeakerPanelAssetsListProps) => {
  const listRef = useRef<HTMLDivElement>(null);

  const handleScrollIntoView = (item: SpeakerViewItem) => {
    const itemElement = document.getElementById(
      `speaker-panel-item-${item.id}`
    );
    if (itemElement && listRef.current) {
      const containerRect = listRef.current.getBoundingClientRect();
      const itemRect = itemElement.getBoundingClientRect();
      itemElement.offsetTop;

      const isCloserToTop =
        Math.abs(itemRect.top - containerRect.top) <
        Math.abs(itemRect.bottom - containerRect.bottom);

      const isInView =
        itemElement.offsetTop >= listRef.current.scrollTop &&
        itemElement.offsetTop <=
          listRef.current.scrollTop + containerRect.height &&
        itemElement.offsetTop + itemRect.height >= listRef.current.scrollTop &&
        itemElement.offsetTop + itemRect.height <=
          listRef.current.scrollTop + containerRect.height;

      if (!isInView) {
        if (isCloserToTop) {
          listRef.current.scrollTop = itemElement.offsetTop - SCROLL_OFFSET;
        } else {
          listRef.current.scrollTop =
            itemElement.offsetTop -
            containerRect.height +
            itemRect.height +
            SCROLL_OFFSET;
        }
      }
    }
  };

  useEffect(() => {
    if (activePresentation !== -1) {
      handleScrollIntoView(items[activePresentation]);
    }
  }, [activePresentation]);

  return (
    <div className="bg-inherit w-full h-ds-260  rounded-md mt-px p-5 flex flex-col select-none scrollbar scrollbar-thumb-gray-900 scrollbar-track-gray-100">
      <div
        ref={listRef}
        className="flex flex-col flex-1 w-full [&::-webkit-scrollbar]:w-[7px] [&::-webkit-scrollbar]:bg-transparent  [&::-webkit-scrollbar-thumb]:rounded  [&::-webkit-scrollbar-thumb]:bg-ds-natural-500  overflow-y-auto scroll-smooth overflow-x-hidden relative gap-2"
      >
        {items.map((item, index) => {
          return (
            <div key={index}>
              <SpeakerPanelItem
                item={item}
                id={index}
                scroll={items?.length > 4}
                onDetach={() => {
                  onDetach(index);
                }}
                dark
                selected={activePresentation === index}
                onSelect={() => setActivePresentation(index)}
                noDrag={true}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default SpeakerPanelAssetsList;
